import * as _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";

/* Load Redux Store */
import { ActionCreator } from "../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../actions/actionCreators";
import { configurationsStoreSelectors } from "../../../../store/store";
import { SoundsOrder } from "../../../../reducers/sounds.reducer";

/* Load Components */
import SoundsFilterHeader from "./SoundsFilterHeader/SoundsFilterHeader.component";
import SoundsTable from "./SoundsTable/SoundsTable.component";
import SoundsPagination from "./SoundsPagination/SoundsPagination.component";

import "./SoundsConfigurationSection.component.scss";
import { ConfigurationsActionTypes } from "../../../../actions/actionTypes";
import {filterItemsBySelectedGames} from "../../../Utils/selected-games";

const GAME_TYPES = {
    0: "Bingo",
    1: "Spins",
    2: "Lotto",
    3: "Keno"
};
export interface SoundsConfigurationSectionProps extends RouteComponentProps {
    editingConfiguration: any;
    getSoundsServer: ActionCreator;
    configSectionVisited: ActionCreator;
    setSoundSettingsOrder: ActionCreator;
    updateSoundSettignsSubLevel: ActionCreator;
    updateSoundSettignsLevel: ActionCreator;
    bulkUpdateSoundSettigns: ActionCreator;
    gameInstances: any;
    gameGroups: any[];
    sounds: any;
    soundsOrder: SoundsOrder;
}

export interface SoundsFilterSelected {
    selectedGroup: number;
    selectedLevel: number;
    selectedSublevel: number;
    selectedGames: string[];
}

export interface SoundsConfigurationSectionState {
    filtersOpen: boolean;
    currentPage: number;
    rowsPerPage: number;
    selectedFilters: SoundsFilterSelected;
}

export class SoundsConfigurationSection extends Component<
    SoundsConfigurationSectionProps,
    SoundsConfigurationSectionState
> {
    constructor(props) {
        super(props);
        this.state = {
            filtersOpen: false,
            currentPage: 0,
            rowsPerPage: 15,
            selectedFilters: {
                selectedGroup: -1,
                selectedLevel: -1,
                selectedSublevel: -1,
                selectedGames: []
            }
        };
    }

    componentDidMount() {
        if (this.props.sounds.length == 0) {
            this.props.getSoundsServer({
                serverId: this.props.match.params["editingServer"],
                subsidiary: this.props.editingConfiguration.subsidiary.id,
                version:
                    this.props.editingConfiguration.settings.version ===
                    undefined
                        ? 0
                        : this.props.editingConfiguration.settings.version
            });
        }

        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_SOUNDS_CONFIG
        );
    }

    toogleFilters = () => {
        this.setState({
            filtersOpen: !this.state.filtersOpen
        });
    };

    goToPage = page => {
        this.setState({
            currentPage: page
        });
    };

    nextPage = () => {
        const pages = Math.ceil(
            this.getSettingswithFilters().length / this.state.rowsPerPage
        );

        if (this.state.currentPage < pages - 1) {
            this.setState({
                currentPage: this.state.currentPage + 1
            });
        }
    };

    previousPage = () => {
        if (this.state.currentPage > 0) {
            this.setState({
                currentPage: this.state.currentPage - 1
            });
        }
    };

    setSoundsSettingLevel = (gameInstanceId, soundGroupId, level) => {
        this.props.updateSoundSettignsLevel({
            gameInstanceId,
            soundGroupId,
            level
        });
    };

    setSoundsSettingSubLevel = (gameInstanceId, soundGroupId, sublevel) => {
        this.props.updateSoundSettignsSubLevel({
            gameInstanceId,
            soundGroupId,
            sublevel
        });
    };

    reorderSounds = (key, direction) => {
        this.props.setSoundSettingsOrder({
            sounds: this.props.sounds,
            order: { key, direction }
        });
    };

    updateFilters = filters => {
        this.setState({
            selectedFilters: filters,
            currentPage: 0
        });
    };

    getSettingswithFilters = () => {
        let soundSettings = filterItemsBySelectedGames(
            this.props.sounds,
            this.props.editingConfiguration.settings.selectedGroupType,
            this.props.gameGroups,
            sound => sound.identifier
        ).filter(sound => {
            return this.props.editingConfiguration.settings.settings.settings.game_types.includes(
                GAME_TYPES[sound.game.type]
            );
        });

        if (this.state.selectedFilters.selectedGames.length > 0) {
            let selfState = this.state.selectedFilters.selectedGames;
            soundSettings = _.filter(soundSettings, function (soundSetting) {
                let belongs = false;
                for (let i = 0; i < selfState.length; i++) {
                    if (soundSetting.description === selfState[i]) {
                        belongs = true;
                        break;
                    }
                }
                return belongs;
            });
        }

        if (this.state.selectedFilters.selectedGroup !== -1) {
            soundSettings = _.filter(soundSettings, {
                id: this.state.selectedFilters.selectedGroup
            });
        }

        if (this.state.selectedFilters.selectedLevel !== -1) {
            soundSettings = _.filter(soundSettings, {
                level: this.state.selectedFilters.selectedLevel
            });
        }

        if (this.state.selectedFilters.selectedSublevel !== -1) {
            soundSettings = _.filter(soundSettings, {
                sub_level: this.state.selectedFilters.selectedSublevel
            });
        }

        return soundSettings;
    };

    applyBulkChanges = (level, subLevel) => {
        const sounds = this.getSettingswithFilters();
        const updatedSoundSettings = sounds.map(levelItem => {
            if (level !== null) {
                levelItem.level = level;
            }

            if (subLevel !== null && levelItem.sub_level_enabled) {
                levelItem.sub_level = subLevel;
            }
            return levelItem;
        });

        this.props.bulkUpdateSoundSettigns({
            sounds: updatedSoundSettings
        });
    };

    render() {
        if (
            this.props.editingConfiguration.settings.settings.settings !==
                null &&
            this.props.editingConfiguration.settings.settings.settings
                .game_types.length == 0
        ) {
            return (
                <div id="SoundsConfigurationSection">
                    <div className="row">
                        <div className="empty-prize-types">
                            <p>
                                <i className="icon-exclamation-circle-light"></i>
                                A game type must be selected in General Settings
                                to be able to configure game sounds.
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        const sounds = this.getSettingswithFilters();

        const pages = Math.ceil(sounds.length / this.state.rowsPerPage);
        const start =
            pages <= this.state.currentPage
                ? 0
                : this.state.currentPage * this.state.rowsPerPage;
        const end = Math.min(start + this.state.rowsPerPage, sounds.length);
        const pageRows = sounds.slice(start, end);
        const total = sounds.length;

        return (
            <div id="SoundsConfigurationSection">
                <div className="row">
                    <div className={"filters-panel open"}>
                        <div>
                            <SoundsFilterHeader
                                selectedFilters={this.state.selectedFilters}
                                updateFilters={this.updateFilters}
                                total={total}
                                applyBulkChanges={this.applyBulkChanges}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div id="sounds-container">
                        <div>
                            {pageRows.length > 0 && (
                                <SoundsTable
                                    rows={pageRows}
                                    start={start + 1}
                                    end={end}
                                    pages={pages}
                                    currentPage={this.state.currentPage}
                                    total={total}
                                    navigationAction={this.goToPage}
                                    reorderAction={this.reorderSounds}
                                    currentOrder={this.props.soundsOrder}
                                    changeLevel={this.setSoundsSettingLevel}
                                    changeSubLevel={
                                        this.setSoundsSettingSubLevel
                                    }
                                />
                            )}
                            {pageRows.length == 0 && (
                                <div className="not-found">
                                    No Sound Settings Found.
                                </div>
                            )}
                            <SoundsPagination
                                rows={pageRows}
                                start={start + 1}
                                end={end}
                                pages={pages}
                                currentPage={this.state.currentPage}
                                total={total}
                                navigationAction={this.goToPage}
                                nextAction={this.nextPage}
                                previousAction={this.previousPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    editingConfiguration: configurationsStoreSelectors.editingConfiguration(
        state
    ),
    gameInstances: configurationsStoreSelectors.gameInstances(state),
    gameGroups: configurationsStoreSelectors.gameGroups(state),
    sounds: configurationsStoreSelectors.sounds(state),
    soundsOrder: configurationsStoreSelectors.soundsOrder(state)
});

const mapDispatchToProps = {
    getSoundsServer: ConfigurationsActionCreators.getSoundsServer,
    setSoundSettingsOrder: ConfigurationsActionCreators.setSoundSettingsOrder,
    updateSoundSettignsLevel:
        ConfigurationsActionCreators.updateSoundSettignsLevel,
    updateSoundSettignsSubLevel:
        ConfigurationsActionCreators.updateSoundSettignsSubLevel,
    bulkUpdateSoundSettigns:
        ConfigurationsActionCreators.bulkUpdateSoundSettigns,
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SoundsConfigurationSection));
